import axios from "axios";
import Vue from "vue";

export function accountCheck (parameter) {
  return axios({
    url:  `${Vue.prototype.putureServerUrl}/puture-dingtalk/quickBi/account/check`,
    method: 'POST',
    params: parameter
  })
}
